import { Observable } from 'rxjs';

import { Space } from '@shure/cloud/shared/models/devices';

export abstract class SpacesApiService {
	public abstract spacesLoadingComplete$: Observable<boolean>;
	public abstract spaceAdded$: Observable<Space>;
	public abstract spaceRemoved$: Observable<string>;
	public abstract spaceSnapshot$: Observable<Space>;

	public abstract getCachedSpaces$(): Observable<Space[]>;
}
